module.exports = __webpack_public_path__ + "static/media/testfile_ssbodyparser.bcea42a1.zip";